const combineReducers = (slices) => (state, action) => Object.keys(slices).reduce(
    (acc, prop) => ({
        ...acc,
        [prop]: slices[prop](acc[prop], action),
    }),
    state,
);

export { combineReducers };
